import { useLocation, useParams } from 'react-router-dom'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { Separator } from '@/components/ui/separator'

function usePageTitle(): string {
  const { pathname } = useLocation()
  const params = useParams<{ service?: string }>()
  const service = params.service ? ` · ${params.service}` : ''
  if (pathname.startsWith('/redirects')) return `Przekierowania${service}`
  return `Reklamy${service}`
}

export function SiteHeader() {
  const title = usePageTitle()
  return (
    <header className="bg-background sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b">
      <div className="flex w-full items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4" />
        <h1 className="text-base font-medium">{title}</h1>
      </div>
    </header>
  )
}
